import { Component, computed, inject, Input, signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';
import { CrmPipelineService, Stage } from '../../../shared-services/crm-services';

@Component({
  template: `
    @if (stageIds().length > 0) {
      @if (selectedStageNames(); as stages) {
        <span>{{ stages }}</span>
      } @else {
        <div class="stencil-shimmer"></div>
      }
    }
  `,
  styles: [
    `
      .stencil-shimmer {
        width: 50px;
        height: 16px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class CrmOpportunityStageFilterChipComponent implements GalaxyAbstractFilterChip {
  @Input() set initialValue(value: GalaxyFilterValueInterface[]) {
    this.stageIds.set(value?.map((v) => v.string ?? '') || []);
  }

  private readonly pipelineService = inject(CrmPipelineService);
  private readonly allStages = toSignal(this.listAllStages());

  protected readonly stageIds = signal<string[]>([]);
  protected readonly selectedStageNames = computed(() => {
    const stageIds = this.stageIds();
    const stages = this.allStages();
    return stageIds
      .map((stageId) => stages?.find((stage) => stage.id === stageId))
      .map((stage) => stage?.name)
      .filter((name) => !!name)
      .join(', ');
  });

  private listAllStages(): Observable<Stage[]> {
    return this.pipelineService.listPipelines$('Opportunity').pipe(
      map((pipelines) => {
        const pipelineId = this.pipelineService.getCurrentPipelineId();
        if (pipelineId) {
          const pipeline = pipelines.find((p) => p.id === pipelineId);
          return pipeline?.stages ?? [];
        }
        const allStages: Stage[] = [];
        for (const pipeline of pipelines) {
          allStages.push(...pipeline.stages);
        }
        return allStages;
      }),
    );
  }
}
